module.exports = __webpack_public_path__ + "img/google-play.d2232aa1.svg";